import { render, staticRenderFns } from "./edit-brand-modal.vue?vue&type=template&id=c05efe22"
import script from "./edit-brand-modal.vue?vue&type=script&lang=js"
export * from "./edit-brand-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports